// Join items into a human-readable list, mirroring <ReactAnd>'s default output
// (Oxford comma), e.g. ["A", "B", "C"] -> "A, B, and C".
export const formatList = (items: string[]): string => {
  if (items.length <= 1) {
    return items[0] ?? '';
  }
  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
};
